/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react'
import {
  StyledRadioButton,
  // StyledCustomRadioButton,
  // StyledButtonLabel,
  StyledSubTitle
} from './style'
import { StyledError } from '../shared-style'
import {
  FieldValues, get, useFormContext
} from 'react-hook-form'
import styled from 'styled-components'
import Check from '../../../assets/icons/check.svg'
import Circle from '../../../assets/icons/circle.svg'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string
  value: string | number
  label?: string
  subLabel?: string
  description?: string
  isDisabled?: boolean
  shouldRegister?: boolean
}

const Radio: React.FC<Props> = ({
  name,
  value,
  label,
  subLabel,
  description,
  required,
  isDisabled = false,
  shouldRegister = true,
  ...props
}: Props) => {
  const {
    register,
    formState: { errors },
    watch
  } = useFormContext<FieldValues>()

  const error = get(errors, name)

  const watchApplicationType = watch(name)

  return (
    <>
        <StyledType>
        { watchApplicationType === value ? <StyledCheckImg src={Check } /> : <StyledCircleImg src={Circle} />}
          <StyledRadioButton
            type="radio"
            value={value}
            {...((shouldRegister && !!register) && register(name))}
            {...props}
          />
          <p>{label} {!!subLabel && <StyledSubTitle className="sub-title">{subLabel}</StyledSubTitle>}</p>
        </StyledType>
      {error && (
        <StyledError>{error || required || 'Invalid input'}</StyledError>
      )}
    </>
  )
}

export default Radio

const StyledType = styled.label`
display: grid;
justify-content: center;
border: 1px solid #3637df26;
border-radius: 8px;
aspect-ratio: 2/1;
grid-template-rows: 1fr 40px;
p {
  font-size: 16px;
}

&:hover {
  cursor:pointer;
}

@media (max-width: 768px) {
  aspect-ratio: auto;
  grid-template-rows: 60px 1fr;
  padding: 10px 0;
}
`

const StyledCheckImg = styled.img`
  width: 40px;
  margin: auto;
  display: block;
  background: #3637df14;
  padding: 10px;
  border-radius: 50%;
`

const StyledCircleImg = styled.img`
  width: 20px;
  margin: auto;
  display: block;
`
